import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { QuizDataType } from '@/modules/types/quiz';

export const quizAdapter = createEntityAdapter();

export interface QuizStateType {
  error?: Error;
  currentQuestionNo: number;
  data: null | QuizDataType;
  result: null | Record<string, any>;
  quizStart: boolean;
}

const initialState: QuizStateType = quizAdapter.getInitialState({
  data: null,
  currentQuestionNo: 1,
  result: null,
  quizStart: false,
});

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    initQuiz: (state, action) => {
      state.data = action.payload;
      state.quizStart = true;
    },
    postResult: (state) => {},
    startQuiz: (state) => {
      state.quizStart = true;
    },
    submitQuizResultSuccess: (state, action) => {
      state.result = action.payload;
    },
    resetResult: (state, action) => {
      state.result = null;
    },
  },
});

export const { name, actions, reducer } = quizSlice;
